import React from 'react';
import { useSpring, animated } from '@react-spring/web'
import { useDrag } from 'react-use-gesture'

const PullRelease = ({props, children}) => {
  const [{ x, y }, api] = useSpring(() => ({ x: 0, y: 0 }))

  // Set the drag hook and define component movement based on gesture data
  //const bind = useDrag(({ down, movement: [mx, my] }) => {
  //  api.start({ x: down ? mx : 0, y: down ? my : 0 })
  //})
  const bind = useDrag(({offset: [x,y]}) => api.start({x, y}));

  // Bind it to a component
  return (
    <animated.div {...bind()} style={{ x, y }}>
      {React.Children.map(children, child => {
        return React.cloneElement(child);
      })}
    </animated.div>
  );
}

export default PullRelease;
